import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

import { type AIInteractionTypeEnum } from './ai'

export type SankeyInteractionType = z.infer<typeof schemas.SankeyInteractionTypeEnum>
export type DateWindow = '1D' | '7D' | '14D' | '30D'
export type ViewType = z.infer<typeof schemas.ViewTypeEnum>
export type AIAnalyticsBaseRequestData = Omit<
  z.infer<typeof schemas.GetOrganizationAIInteractionStatsRequestData>,
  'interaction_type'
>
export type AIInteractionFlow = z.infer<
  typeof schemas.GetOrganizationAIInteractionFlowsResponseData
>
export type FrontDeskInteractionType = z.infer<typeof schemas.FrontDeskInteractionTypeEnum>

export const SANKEY_TO_AI_INTERACTION_TYPE: Record<SankeyInteractionType, AIInteractionTypeEnum> = {
  search: 'SEARCH',
  chat: 'CHAT',
  voice: 'VOICE',
}

export const DATE_WINDOW_OPTIONS: Record<DateWindow, string> = {
  '1D': 'Last day',
  '7D': 'Last 7 days',
  '14D': 'Last 14 days',
  '30D': 'Last 30 days',
}

export const INTERACTION_STATUSES = ['handled', 'not_handled'] as const

export type WorkflowUsageDashboardStats = z.infer<
  typeof schemas.GetWorkflowUsageDashboardStatsViewResponseData
>['workflow_usage_stats']
export type OrgWorkflowScorecard = z.infer<typeof schemas.GetOrgWorkflowScorecardViewResponseData>
export type IdentifiedWorkflows = z.infer<typeof schemas.GetIdentifiedWorkflowsViewResponseData>
